import { Component, OnInit, inject } from '@angular/core';
import { FullScreenService } from '../../../services/full-screen.service';
import { UserService } from '../../../services/user/user.service';
import { GameIframeService } from '../../../services/games/game-iframe.service';
import { first } from 'rxjs/operators';
import { DraggableDirective } from '../../directives/draggable.directive';
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-game-iframe',
    templateUrl: './game-iframe.component.html',
    styleUrls: ['./game-iframe.component.scss'],
    imports: [DraggableDirective, NgClass]
})
export class GameIframeComponent implements OnInit {
  gameIframe = inject(GameIframeService);
  user = inject(UserService);
  fullScreen = inject(FullScreenService);


  /**
   * Toggle when drag and display div for right dragging working
   */
  public dragging: boolean;

  ngOnInit() {

  }

  public updateWallet() {
    this.user.updateAllAccountsWalletList().pipe(first()).subscribe();
  }

}
